import { keyframes } from "styled-components";

export const turn180 = keyframes`
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(-180deg);
  }
`;

export const fadeInOut = keyframes`
  0% {
    opacity: 0.2;
  }
  50% {
    opacity: 0.6;
  }
  100%{
    opacity: 0.2;
  }
`;

export const SlideUp = keyframes`
  0% {
    opacity: .4;
    transform: translateY(22px);
  }
  100% {
    transform: translateY(0px);
    opacity: 1;
  }
`;

export const fadeIn = keyframes`
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
`;
